module.exports = "https://cdn.redage.net/src/views/player/documets/fib/images/fib_logo.png";